var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1487 21.0673H4.29907V1.73047H8.99587",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6687 1.73047H18.3679V16.8457",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48169 7.40625H15.1857",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48169 10.0684H15.1857",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48169 12.7295H15.1857",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48169 15.3916H15.1857",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 0.916409V3.31641C8.99609 3.37051 9.00679 3.42407 9.02756 3.47402C9.04834 3.52397 9.07878 3.56932 9.11714 3.60746C9.15551 3.6456 9.20103 3.67578 9.2511 3.69626C9.30117 3.71674 9.3548 3.72713 9.40889 3.72681H9.57209C9.67211 3.72757 9.76892 3.69157 9.84414 3.62565C9.91936 3.55972 9.96774 3.46846 9.98009 3.36921V3.31881C10.0255 2.97225 10.1955 2.65405 10.4582 2.42354C10.721 2.19303 11.0586 2.06596 11.4081 2.06601V2.06601C11.7597 2.06303 12.1002 2.18878 12.3655 2.41956C12.6307 2.65034 12.8024 2.97019 12.8481 3.31881V3.36921C12.8609 3.46825 12.9095 3.55921 12.9846 3.62504C13.0597 3.69087 13.1562 3.72705 13.2561 3.72681V3.72681C13.3649 3.72681 13.4693 3.68357 13.5463 3.60661C13.6233 3.52964 13.6665 3.42525 13.6665 3.31641V0.916409C13.6665 0.832803 13.6334 0.752585 13.5746 0.693242C13.5157 0.633899 13.4357 0.600243 13.3521 0.599609H9.31529C9.23105 0.599607 9.15022 0.632907 9.09043 0.692251C9.03064 0.751594 8.99673 0.832169 8.99609 0.916409V0.916409Z",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3454 23.3998C19.1997 23.3998 20.703 21.8965 20.703 20.0422C20.703 18.1878 19.1997 16.6846 17.3454 16.6846C15.491 16.6846 13.9878 18.1878 13.9878 20.0422C13.9878 21.8965 15.491 23.3998 17.3454 23.3998Z",
    stroke: "#F5B335",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8792 20.0309L17.2352 21.2405L19.1887 18.8477",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3cbfad85c72556756ad5870cfdd1945f.svg";
export { ForwardRef as ReactComponent };